<template>
  <div class="vx-col w-full">
    <vx-card title="Guarantor Personal Information">
      <br>
      <div class="vx-row">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full mt-2">
              <span>Guarantor’s Name (with Nick Name)</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input class="w-full" type="text" v-model="personal.applicantName"/>
            </div>
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full mt-2">
              <span>Father’s Name</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input class="w-full" type="text" v-model="personal.fathersName"/>
            </div>
          </div>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full mt-2">
              <span>Mother’s Name</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input class="w-full" type="text" v-model="personal.motherName"/>
            </div>
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full mt-2">
              <span>Age</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <ul class="demo-alignment">
                <li>
                  <vs-radio v-model="personal.age" vs-value="18-25">18-25</vs-radio>
                </li>
                <li>
                  <vs-radio v-model="personal.age" vs-value="26-35">26-35</vs-radio>
                </li>
                <li>
                  <vs-radio v-model="personal.age" vs-value="36-45">36-45</vs-radio>
                </li>
                <li>
                  <vs-radio v-model="personal.age" vs-value="46-55">46-55</vs-radio>
                </li>
                <li>
                  <vs-radio v-model="personal.age" vs-value="56-65">56-65</vs-radio>
                </li>
                <li>
                  <vs-radio v-model="personal.age" vs-value="66+">66+</vs-radio>
                </li>
              </ul>
              <!--<datepicker placeholder="Select Date" v-model="birthDate"></datepicker>-->
            </div>
          </div>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full mt-4">
              <span>Gender</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <ul class="demo-alignment">
                <li>
                  <vs-radio v-model="personal.gender" vs-value="Male">Male</vs-radio>
                </li>
                <li>
                  <vs-radio v-model="personal.gender" vs-value="Female">Female</vs-radio>
                </li>
                <li>
                  <vs-radio v-model="personal.gender" vs-value="Others">Others</vs-radio>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full mt-4">
              <span>Marital Status</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <ul class="demo-alignment">
                <li>
                  <vs-radio v-model="personal.maritalStatus" vs-value="Single">Single</vs-radio>
                </li>
                <li>
                  <vs-radio v-model="personal.maritalStatus" vs-value="Married">Married</vs-radio>
                </li>
                <li>
                  <vs-radio v-model="personal.maritalStatus" vs-value="Separated">Separated</vs-radio>
                </li>
                <li>
                  <vs-radio v-model="personal.maritalStatus" vs-value="Divorced">Divorced</vs-radio>
                </li>
                <li>
                  <vs-radio v-model="personal.maritalStatus" vs-value="Widowed">Widowed</vs-radio>
                </li>
              </ul>

            </div>
          </div>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full mt-2">
              <span>Spouse Name</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input v-if="personal.maritalStatus !== 'Single'" class="w-full" type="text" v-model="personal.spouseName"/>
            </div>
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full mt-4">
              <span>Head of Household</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <ul class="demo-alignment">
                <li>
                  <vs-radio v-model="personal.headOfHousehold" :vs-value="true">Yes</vs-radio>
                </li>
                <li>
                  <vs-radio v-model="personal.headOfHousehold" :vs-value="false">No</vs-radio>
                </li>
              </ul>

            </div>
          </div>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full mt-4">
              <span>Education Level</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <template>
                <v-select label="text" v-model="personal.education" class="w-full select-large"
                          :options="educationLevelOpt" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
              </template>
            </div>
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full mt-2">
              <span>NID No</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input class="w-full" required type="number" v-model="personal.nidNo"/>
            </div>
          </div>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col sm:w-1/3 w-full mb-2">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full mt-16">
              <span>Nid Front (Max 300 KB) (জাতীয় পরিচয়পত্রের সামনের দিক) <sup> *</sup></span>
            </div>
            <div class="vx-col sm:w-2/3 w-full mt-16">
              <div v-if="nidFrontUrl" class="preview-image">
                <img  :src="nidFrontUrl"/>
                <span @click="removeNidFront">X</span>
              </div>
              <label v-if="nidFrontUrl === ''" class="custom-file-upload">
                <input type="file" v-validate="'required'" data-vv-as="NID Front" class="uploadBtn" required @change="successNidFrontUpload" name="personal.nidFrontImage"> Nid Front
              </label>
              <span class="text-danger text-sm" v-show="errors.has('personal.nidFrontImage')">{{ errors.first('personal.nidFrontImage') }}</span>
              <!--<template>
                <vs-upload  :data="personal.nidFrontImage" fileName="nidFront" text="NID Front" @change="successNidUpload"/>
              </template>-->
            </div>
          </div>
        </div>
        <div class="vx-col sm:w-1/3 w-full mb-2">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full mt-16">
              <span>Nid Back (Max 300 KB) (জাতীয় পরিচয়পত্রের পেছনের দিক)<sup>*</sup></span>
            </div>
            <div class="vx-col sm:w-2/3 w-full mt-16">
              <div v-if="nidBackUrl" class="preview-image">
                <img  :src="nidBackUrl"/>
                <span @click="removeNidBack">X</span>
              </div>
              <label v-if="nidBackUrl === ''" class="custom-file-upload">
                <input type="file" v-validate="'required'" data-vv-as="NID Back" name="personal.nidBackImage" class="uploadBtn" required @change="successNidBackUpload"> Nid Back
              </label>
              <span class="text-danger text-sm" v-show="errors.has('personal.nidBackImage')">{{ errors.first('personal.nidBackImage') }}</span>
              <!--<input type="file" @change="successNidBanckUpload">-->
              <!--<template>
                <vs-upload text="NID Back"
                           @on-success="successNidUpload"/>
              </template>-->
            </div>
          </div>
        </div>
        <div class="vx-col sm:w-1/3 w-full mb-2">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full mt-16">
              <span>Upload Photo (Max 300 KB) (ব্যাক্তিগত ছবি আপলোড করুন )<sup> *</sup></span>
            </div>
            <div class="vx-col sm:w-2/3 w-full mt-16">
              <div v-if="applicantPhotoUrl" class="preview-image">
                <img :src="applicantPhotoUrl"/>
                <span @click="removePhoto">X</span>
              </div>
              <label v-if="applicantPhotoUrl === ''" class="custom-file-upload-app">
                <input type="file" v-validate="'required'" data-vv-as="Photo" name="personal.applicantPhoto" class="uploadBtn" required @change="successAppPhotoUpload"> Photo
              </label>
              <span class="text-danger text-sm" v-show="errors.has('personal.applicantPhoto')">{{ errors.first('personal.applicantPhoto') }}</span>
              <!--<input type="file" @change="successAppPhotoUpload">-->
              <!--<template>
                <vs-upload text="Photo Upload"
                           @on-success="successUpload"/>
              </template>-->
            </div>
          </div>
        </div>
      </div>
      <!--<div class="vx-row">
        <div class="vx-col sm:w-1/3 w-full mb-2">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full mt-16">
              <span>Nid Front</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <template>
                <vs-upload text="NID Front" v-model="personal.nidFrontImage"
                           @on-success="successNidUpload"/>
              </template>
            </div>
          </div>
        </div>
        <div class="vx-col sm:w-1/3 w-full mb-2">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full mt-16">
              <span>Nid Back</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <template>
                <vs-upload text="NID Back" action="https://jsonplaceholder.typicode.com/posts/"
                           @on-success="successNidUpload"/>
              </template>
            </div>
          </div>
        </div>
        <div class="vx-col sm:w-1/3 w-full mb-2">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full mt-16">
              <span>Upload Photo</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <template>
                <vs-upload text="Photo Upload" action="https://jsonplaceholder.typicode.com/posts/"
                           @on-success="successUpload"/>
              </template>
            </div>
          </div>
        </div>
      </div>-->
      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <vs-button
            color="success" class="mr-3 mb-2 float-right" @click="updatePersonalInfo()">Update
          </vs-button>

        </div>
      </div>
    </vx-card>
  </div>
</template>
<script>

  import updateGuarantorPersonalInfo from '../graphql/GuarantorPersonalUpdate.gql'
  import {ME} from '../graphql/userinfo'
  import {onLogin} from '../vue-apollo'
  //import {FormWizard, TabContent} from 'vue-form-wizard'
  //import 'vue-form-wizard/dist/vue-form-wizard.min.css'
  import gql from 'graphql-tag'
  import vSelect from 'vue-select'
  import Datepicker from 'vuejs-datepicker'
  export default {
    data () {
      return {
        userInfo: '',
        contactTab: true,
        personalInfo:'',
        personal: {
          applicantName: '',
          fathersName: '',
          motherName: '',
          spouseName: '',
          age: '',
          maritalStatus: '',
          gender: '',
          headOfHousehold: true,
          education: '',
          nidNo: '',
          nidFrontImage: '',
          nidBackImage: '',
          applicantPhoto: ''
        },
        educationLevelOpt: [
          {
            text: 'SSC or O Level',
            value: 'SSC or O Level'
          },
          {
            text: 'HSC or A Level',
            value: 'HSC or A Level'
          },
          {
            text: 'Diploma',
            value: 'Diploma'
          },
          {
            text: 'Bachelor\'s ',
            value: 'Bachelor\'s '
          },
          {
            text: 'Master\'s',
            value: 'Master\'s'
          },
          {
            text: 'Doctorate',
            value: 'Doctorate'
          }
        ],
        nidFrontUrl:'',
        nidBackUrl:'',
        applicantPhotoUrl:'',
      }

    },
    apollo: {
      guarantor: {
        query: gql`
         query guarantor($id: ID!){
          guarantor(id:$id){
            id
            name
            phone
            email
            relationship
            status
            ekyc {
              id
              phone
              nid
              email
              status
              parsonal {
                id
                name
                father_name
                mother_name
                spouse_name
                age
                marital_status
                gender
                head_of_household
                education_level
                nid
                nid_front
                nid_back
                photo
              }
            }
          }
         }
         `,
        variables () {
          return {
            id: this.$route.params.guarantorId
          }
        },
        update: (data) => data.guarantor
      }

    },
    watch: {
      guarantor (value) {
        this.guarantor = value;
        console.log('GuarantorByID : =', value);
        if(value.ekyc !== null){
          this.userInfo = value.ekyc;
          if(value.ekyc.parsonal !==null){
            this.personalInfo = value.ekyc.parsonal;
            this.personal.applicantName = this.personalInfo.name;
            this.personal.fathersName = this.personalInfo.father_name;
            this.personal.motherName = this.personalInfo.mother_name;
            this.personal.spouseName = this.personalInfo.spouse_name;
            this.personal.age = this.personalInfo.age;
            this.personal.maritalStatus = this.personalInfo.marital_status;
            this.personal.gender = this.personalInfo.gender;
            this.personal.headOfHousehold = this.personalInfo.head_of_household;
            this.personal.education = this.personalInfo.education_level;
            this.personal.nidNo = this.personalInfo.nid;
            this.nidFrontUrl = this.personalInfo.nid_front
            this.nidBackUrl = this.personalInfo.nid_back
            this.applicantPhotoUrl = this.personalInfo.photo
            if(this.nidFrontUrl){
              fetch(this.nidFrontUrl)
                .then(async response => {
                  const contentType = response.headers.get('content-type')
                  const blob = await response.blob()
                  console.log("BBBBl :", blob.type, contentType)
                  const fileFr = new File([blob], this.nidFrontUrl, { contentType })
                  this.personal.nidFrontImage = fileFr;
                  console.log("BBBB-->> :", fileFr)
                })
            }
            if(this.nidBackUrl){
              fetch(this.nidBackUrl)
                .then(async response => {
                  const contentType = response.headers.get('content-type')
                  const blob = await response.blob()
                  const fileBk = new File([blob], this.nidBackUrl, { contentType })
                  this.personal.nidBackImage = fileBk;

                })
            }
            if(this.applicantPhotoUrl){
              fetch(this.applicantPhotoUrl)
                .then(async response => {
                  const contentType = response.headers.get('content-type')
                  const blob = await response.blob()
                  const filePhoto = new File([blob], this.applicantPhotoUrl, { contentType })
                  this.personal.applicantPhoto = filePhoto;
                })
            }
          }
        }
      }
    },
    methods: {
      async updatePersonalInfo () {
        console.log("Update :", this.personal)
        await this.$apollo.mutate({
          mutation: updateGuarantorPersonalInfo,
          variables: {
            guarantor_id: this.$route.params.guarantorId,
            ekyc_id: this.$route.params.ekycId,
            name: this.personal.applicantName,
            father_name: this.personal.fathersName,
            mother_name: this.personal.motherName,
            spouse_name: this.personal.spouseName,
            age: this.personal.age,
            marital_status: this.personal.maritalStatus,
            gender: this.personal.gender,
            head_of_household: this.personal.headOfHousehold,
            education_level: this.personal.education ===null? "": this.personal.education.value,
            nid: this.personal.nidNo,
            nid_front: this.personal.nidFrontImage,
            nid_back: this.personal.nidBackImage,
            photo: this.personal.applicantPhoto
          }
        }).then((data) => {
          console.log('Data = ', data);
          this.$router.push('/applicationDetails/'+ this.$route.params.purchaseId).catch(() => {});
          this.$apollo.queries.guarantor.refetch();
          this.$vs.notify({
            title: 'Updated',
            text: 'Personal Information Successfully Updated.',
            color: "success",
            position: 'top-right'
          })
          this.contactTab = true
          console.log('this.contactTab = ', this.contactTab)
        }).catch((error) => {
        })
      },
      successNidFrontUpload (event) {
        console.log("Upload",event)
        this.personal.nidFrontImage = event.target.files[0];
        this.nidFrontUrl = URL.createObjectURL(this.personal.nidFrontImage);
        console.log("URL",this.nidFrontUrl)
      },
      removeNidFront () {
        this.personal.nidFrontImage = '';
        this.nidFrontUrl = ''
      },
      successNidBackUpload (event) {
        console.log("Upload",event.target.files[0])
        this.personal.nidBackImage = event.target.files[0];
        this.nidBackUrl = URL.createObjectURL(this.personal.nidBackImage);
      },
      removeNidBack () {
        this.personal.nidBackImage = '';
        this.nidBackUrl = ''
      },
      successAppPhotoUpload (event) {
        console.log("Upload",event.target.files[0])
        this.personal.applicantPhoto = event.target.files[0];
        this.applicantPhotoUrl = URL.createObjectURL(this.personal.applicantPhoto);
      },
      removePhoto () {
        this.personal.applicantPhoto = '';
        this.applicantPhotoUrl = ''
      },
      successNidUpload () {
        this.$vs.notify({
          color: 'success',
          title: 'Upload Success',
          text: 'NID Successfully Uploaded'
        })
      },
      successUpload () {
        this.$vs.notify({
          color: 'success',
          title: 'Upload Success',
          text: 'Photo Successfully Uploaded'
        })
      },
    },
    components: {
      //FormWizard,
      //TabContent,
      'v-select': vSelect,
      Datepicker
    }
  }
</script>
<style scoped>
  label.custom-file-upload input[type="file"] {
    display: none;
  }
  label.custom-file-upload-app input[type="file"] {
    display: none;
  }

  label.custom-file-upload {
    border: 1px solid #28c76f;
    padding: 35px 25px;
    border-radius: 6px;
    /*background: url(".././assets/images/portrait/small/nidIcon.png")no-repeat, center, center;*/
    background-size: cover;
  }
  label.custom-file-upload-app {
    border: 1px solid #28c76f;
    padding: 35px 25px;
    border-radius: 6px;
    /*background: url(".././assets/images/portrait/small/profile.png")no-repeat, center, center;*/
    background-size: cover;
  }
  label.custom-file-upload:hover{
    cursor: pointer;
  }
  label.custom-file-upload-app:hover{
    cursor: pointer;
  }
  .preview-image img {
    border: 1px dotted #28c76f;
    border-radius: 5px;
    width: auto;
    height: 110px;
    padding: 5px;
  }
  .preview-image{
    position: relative;
  }
  .preview-image span {
    position: ABSOLUTE;
    top: 0;
    left: 96px;
    height: 25px;
    width: 25px;
    background: #7367f0;
    text-align: center;
    padding: 5px;
    color: #fff;
    border-radius: 100%;
    font-size: 11px;
    cursor: pointer;
  }
  .preview-image span:hover{
    background: red;
  }
  sup {
    font-size: 16px;
    color: red;
  }
</style>
